//-------- OPEN FILTER ---------//

function openOneFilter(id) {
  // close all filters
  const allTriggers = document.querySelectorAll('#CollectionSidebarFilterWrap .collapsible-trigger-btn.is-open');

  allTriggers.forEach(trigger => {
    if (trigger.dataset.collapsibleId !== id) {
      // newClickCounter+=1
      trigger.click()
    }
  });
}
//-------- END OPEN FILTER ---------//

function changeFilterContainerSize() {
  setTimeout(() => {
    if (window.innerWidth > 768) {
      let containerFilter = document.querySelector('.collections-page__filter-wrapper')
      let filtersContentHeight = document.querySelector('.collections-page__collapsible-content.is-open')
      let triggerContainerHeight = document.querySelector('.collections-page__filter-form')
      let removeFilterHeight = document.querySelector('.tag-list--active-tags')

      if (filtersContentHeight && triggerContainerHeight) {
        filtersContentHeight = filtersContentHeight.getBoundingClientRect().height
        triggerContainerHeight = triggerContainerHeight.getBoundingClientRect().height
        removeFilterHeight = removeFilterHeight.getBoundingClientRect().height
        containerFilter.style.minHeight = (filtersContentHeight + triggerContainerHeight + removeFilterHeight)+'px';
      } else if (containerFilter) {
        containerFilter.style.minHeight = '0px';
      }
    }
    }, 200);
}

window.addEventListener('resize', () => {
  window.innerWidth > 768 && changeFilterContainerSize()
})



// HEADER CODE
const navLinkWithDropdown = document.querySelectorAll('.site-nav__link--has-dropdown')
const header = document.querySelector('.header__container')
const allNav = document.querySelectorAll('.site-nav__link')

function turnHeaderWhite(hasHero) {
  header.classList.add('header__container--white')
  document.querySelector('.site-header__logo a').classList.add('site-nav__link--black')
  allNav.forEach(nav => nav.classList.add('site-nav__link--black'))
  if (hasHero) {
    document.querySelector('.header-wrapper').classList.remove('is-light')
  }
}

function turnHeaderColorToOriginal(hasHero) {
  header.classList.remove('header__container--white')
  document.querySelector('.site-header__logo a').classList.remove('site-nav__link--black')
  allNav.forEach(nav => nav.classList.remove('site-nav__link--black'))
  if (hasHero) {
    document.querySelector('.header-wrapper').classList.add('is-light')
  }
}



// CART REMOVE
function deleteItemFromCart (itemId) {
  let addData = {
    updates: {}
  }

  addData.updates[itemId] = 0

  fetch('/cart/update.js', {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    },
    body: JSON.stringify(addData)
  })
    .then((response) => {
      if (response.status === 200) {
        document.dispatchEvent(new Event('cart:build'))
      }
    })
    .catch((error) => {
      console.log('catch', error)
    })
}
